import React, { useState, useEffect } from 'react';
import StudentTemplate from '../../component/StudentTemplate';
import { ToastContainer, toast } from 'react-toastify';
import '../../Assets/css/responsiveptable.css';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Api from '../../component/Api';
import Select from 'react-select';
import Loader from '../../component/Loader.js';
const   Resultview = () => {
    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/")
    }




    const { http } = Api();
    // const tableData1 = [
    //     {
    //         category: "DSC 1",
    //         course: "MG1DSCCHE100 - Course Name",
    //         credits: 4,
    //         theory: { cca: 20, ccaMax: 25, ese: 40, eseMax: 50, total: 60, max: 75, result: "Pass" },
    //         practical: { cca: 7, ccaMax: 7.5, ese: 10, eseMax: 17.5, total: 17, max: 25, result: "Pass" },
    //         totalSecured: 77,
    //         maxMarks: 100,
    //         grade: "B+",
    //         gradePoints: 7,
    //         acquiredCredits: 4,
    //         creditPoint: 28,
    //         overallResult: "Pass",
    //     },
    //     {
    //         category: "DSC 2",
    //         course: "MG1DSCCHE100 - Course Name",
    //         credits: 4,
    //         theory: { cca: 20, ccaMax: 25, ese: 40, eseMax: 50, total: 60, max: 75, result: "Pass" },
    //         practical: { cca: 7, ccaMax: 7.5, ese: 10, eseMax: 17.5, total: 17, max: 25, result: "Pass" },
    //         totalSecured: 77,
    //         maxMarks: 100,
    //         grade: "B+",
    //         gradePoints: 7,
    //         acquiredCredits: 4,
    //         creditPoint: 28,
    //         overallResult: "Pass",
    //     },
    //     {
    //         category: "DSC 3",
    //         course: "MG1DSCCHE100 - Course Name",
    //         credits: 4,
    //         theory: { cca: 20, ccaMax: 25, ese: 40, eseMax: 50, total: 60, max: 75, result: "Pass" },
    //         practical: { cca: 7, ccaMax: 7.5, ese: 10, eseMax: 17.5, total: 17, max: 25, result: "Pass" },
    //         totalSecured: 77,
    //         maxMarks: 100,
    //         grade: "B+",
    //         gradePoints: 7,
    //         acquiredCredits: 4,
    //         creditPoint: 28,
    //         overallResult: "Pass",
    //     },
    //     {
    //         category: "MDC",
    //         course: "MG1DSCCHE100 - Course Name",
    //         credits: 4,
    //         theory: { cca: 20, ccaMax: 25, ese: 40, eseMax: 50, total: 60, max: 75, result: "Pass" },
    //         practical: { cca: 7, ccaMax: 7.5, ese: 10, eseMax: 17.5, total: 17, max: 25, result: "Pass" },
    //         totalSecured: 77,
    //         maxMarks: 100,
    //         grade: "B+",
    //         gradePoints: 7,
    //         acquiredCredits: 4,
    //         creditPoint: 28,
    //         overallResult: "Pass",
    //     },
    //     {
    //         category: "AEC 1",
    //         course: "MG1DSCCHE100 - Course Name",
    //         credits: 4,
    //         theory: { cca: 20, ccaMax: 25, ese: 40, eseMax: 50, total: 60, max: 75, result: "Pass" },
    //         practical: { cca: 7, ccaMax: 7.5, ese: 10, eseMax: 17.5, total: 17, max: 25, result: "Pass" },
    //         totalSecured: 77,
    //         maxMarks: 100,
    //         grade: "B+",
    //         gradePoints: 7,
    //         acquiredCredits: 4,
    //         creditPoint: 28,
    //         overallResult: "Pass",
    //     },
    //     {
    //         category: "AEC 2",
    //         course: "MG1DSCCHE100 - Course Name",
    //         credits: 4,
    //         theory: { cca: 20, ccaMax: 25, ese: 40, eseMax: 50, total: 60, max: 75, result: "Pass" },
    //         practical: { cca: 7, ccaMax: 7.5, ese: 10, eseMax: 17.5, total: 17, max: 25, result: "Pass" },
    //         totalSecured: 30,
    //         maxMarks: 100,
    //         grade: "F",
    //         gradePoints: 0,
    //         acquiredCredits: 0,
    //         creditPoint: 0,
    //         overallResult: "Fail",
    //     },

    // ];
    const [examid, setExamIdData] = useState('');
    const [tableData, setTableData] = useState([]);
    const [containerClass, setContainerClass] = useState("my-page");
    const [loading, setLoading] = useState(false);
    const [isMalpractice, setMalpractice] = useState(false);

    const [getexamData, setExamData] = useState([]);
    const [gradePoints, setGradePoints] = useState([]);


    useEffect(() => {

        const fetchExamData = async () => {
            try {
                const response = await http.get(`/getstudentActiveExam`);

                console.log("response", response.data);
                setExamData(response.data.activeexam);
            }
            catch (error) {
                if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
                    toast.error("No active exam found");
                }
                else {
                    toast.error("Something went wrong");
                }
            }
        };

        fetchExamData();
    }, []);

    const handleChangeExam = async (selectedOption) => {
        const selectedExamId = selectedOption?.value;
        setExamIdData(selectedExamId); // Update the selected exam ID

        try {
            const response = await http.get('/Student/getStudentResult', {
                params: { examid: selectedExamId },
            });


            // toast.success(response.data.message || "Data fetched successfully");
            console.log("result==", response.data.result);


            setGradePoints(response.data.gradeDetails.concatenated_result);
            const apiData = Array.isArray(response.data.result) ? response.data.result : [];
            console.log("apiData==", apiData);

            const hasMalpractice = apiData.filter(
                (item) => (item.student_status && item.student_status.toLowerCase() === "malpractise")
            );
            console.log({hasMalpractice})
            setMalpractice(hasMalpractice.length > 0);

            const mappedData = apiData.map((item) => ({
                category: item.paper_identifier || "-",
                course: item.course_name || "-",
                coursecd: item.course_code || "-",
                credits: item.credit || "-",
                theory: {
                    cca: (item.theory_pract === "T" || item.theory_pract === "B") ?
                        (item.normalised_TI || "-") : "-",
                    ccaMax: (item.theory_pract === "T" || item.theory_pract === "B") ?
                        (item.normalised_TI_MAX || "-") : "-",
                    ese: (item.theory_pract === "T" || item.theory_pract === "B") ?
                        (item.normalised_TE || "-") : "-",
                    eseMax: (item.theory_pract === "T" || item.theory_pract === "B") ?
                        (item.normalised_TE_MAX || "-") : "-",
                    total: (item.theory_pract === "T" || item.theory_pract === "B") ?
                        (item.T_Total || "-") : "-",
                    max: (item.theory_pract === "T" || item.theory_pract === "B") ?
                        (item.normalised_T_Max || "-") : "-",
                    theory_result: (item.theory_pract === "T" || item.theory_pract === "B") ?
                        (item.theory_result || "-") : "-",
                },
                practical: {
                    cca: (item.theory_pract === "P" || item.theory_pract === "B") ?
                        (item.normalised_PI || "-") : "-",
                    ccaMax: (item.theory_pract === "P" || item.theory_pract === "B") ?
                        (item.normalised_PI_MAX || "-") : "-",
                    ese: (item.theory_pract === "P" || item.theory_pract === "B") ?
                        (item.normalised_PE || "-") : "-",
                    eseMax: (item.theory_pract === "P" || item.theory_pract === "B") ?
                        (item.normalised_PE_MAX || "-") : "-",
                    total: (item.theory_pract === "P" || item.theory_pract === "B") ?
                        (item.P_Total || "-") : "-",
                    max: (item.theory_pract === "P" || item.theory_pract === "B") ?
                        (item.normalised_P_Max || "-") : "-",
                    practical_result: (item.theory_pract === "P" || item.theory_pract === "B") ?
                        (item.practical_result || "-") : "-",
                },
                totalSecured: item.Total_Mark || "-",
                maxMarks: item.Total_Mark_Max || "-",
                grade: item.grade || "-",
                gradePoints: item.GP || "-",
                acquiredCredits: item.acquired_credit || "-",
                creditPoint: item.credit_point || "-",
                overallResult: item.result || "-",
            }));
            setTableData(mappedData);

        } catch (error) {
            const status = error.response?.data?.http_status;
            const message = error.response?.data?.message || "An error occurred";

            if (status === 500 || error.response?.data?.status_code === "ERR5") {
                toast.error(message);
            } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => navigate("/college/"), 5000);
            } else {
                toast.error(message);
            }
        }
    };
    console.log("tableData", tableData);
    //   call the specific class when screen less than 600px
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 600) {
                setContainerClass("my-page1");
            } else {
                setContainerClass("my-page");
            }
        };

        // Set the initial class based on the screen width
        handleResize();

        // Add event listener for window resize
        window.addEventListener("resize", handleResize);

        // Cleanup listener on unmount
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    const downloadPdf = async () => {

        setLoading(true);
        try {
            const response = await http.get('Result/StudentProfileResultpdf', {
                params: {
                    examid: examid
                },
                responseType: 'blob',
            });

            if (response && response.data) {
                // Create a URL for the downloaded file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                // Set the file name and download the PDF
                link.setAttribute('download', `ExamResult.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoading(false);
                return Promise.resolve('PDF generated successfully');
            }

        } catch (error) {
            setLoading(false);

            if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);

            }
            else if (error.response.status === 422) {
                //console.log("ERROR==",error.response.message);
                //toast.error(error.response.message);
                toast.error('Invalid Captcha');

            }
            else {
                console.error('Error generating PDF:', error);
                toast.error('Error generating PDF');
            }

            //toast.error('Error generating PDF');
        }

    }


    return (
        <>
            <StudentTemplate>
                <ToastContainer />
                {loading ? (

                    // <div className="container-fluid">
                    //     <div className="row justify-content-center align-items-center">
                    //         <div className="col-sm-12">
                    //             <div className="card h-100">
                    //                 <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                    //                     <div className="containeranimate">
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //         </div>
                    //     </div>
                    // </div>
                    <Loader />
                ) : (
                    <div className={containerClass}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    {/* <div className="card">
                                        <div className="card-header card-heading mobile">
                                            <div className="d-flex justify-content-between align-items-center">

                                                <div className="card-body">
                                                    <h4 className="card-title text-center font-weight-bold text-black mobile">

                                                        MGU UGP Examination Results
                                                    </h4>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="card">
                                            <div className="card-header">
                                                <div className="py-3 st-hed-pb d-flex justify-content-center align-items-center text-center mobile">
                                                    <h4 className='mobile'>MGU UGP Examination Results</h4>

                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="mb-4">
                                                    <Select
                                                        maxMenuHeight={200}
                                                        menuPlacement="auto"
                                                        id="exam_id"
                                                        name="exam_id"
                                                        className="basic-select"
                                                        classNamePrefix="select"
                                                        onChange={handleChangeExam}

                                                        options={getexamData.map(exam => ({
                                                            value: exam.examid,
                                                            label: exam.examtitle
                                                        }))}

                                                        placeholder="Select an exam..."
                                                    />
                                                </div>


                                                {tableData.length > 0 && (
                                                    <div className="buttons-container m-t-5 m-b-20 nav-right">
                                                        <button
                                                            className="lbl2 btn btn-primary"
                                                            onClick={() => downloadPdf()} // Corrected the function call
                                                            title="Download"
                                                        >
                                                            <i className="bi bi-arrow-down-square"></i>
                                                        </button>
                                                    </div>
                                                )}

                                                <div className='ex-table-container'
                                                    style={{
                                                        overflowX: "auto", // Enable horizontal scrolling
                                                        maxWidth: "100%", // Ensure it respects parent width
                                                    }}
                                                >
                                                    {tableData && tableData.length > 0 ? (
                                                        <>
                                                            <table className="table ex-table1  m-b-30 table-striped" style={{ width: "270%" }} >
                                                                <thead>

                                                                    <tr>
                                                                        <th rowSpan={2} style={{ width: '4%', verticalAlign: "middle" }} >Category</th>
                                                                        <th rowSpan={2} style={{ width: '10%', verticalAlign: "middle", textAlign: 'center   ' }}>Course</th>
                                                                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }} >Credits</th>
                                                                        <th colSpan={7} style={{ textAlign: 'center', verticalAlign: "middle", backgroundColor: '#DF7886', color: 'white' }}>Theory</th>
                                                                        <th colSpan={7} style={{ textAlign: 'center', verticalAlign: "middle", backgroundColor: '#C45966', color: 'white' }} >Practical</th>

                                                                        <th rowSpan={2} style={{ verticalAlign: "middle", textAlign: 'center' }} >Total marks secured</th>
                                                                        <th rowSpan={2} style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', verticalAlign: "middle" }}>Maximum marks</th>
                                                                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }} >Grade</th>
                                                                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }} >Grade Points</th>
                                                                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }}>Acquired Credits</th>
                                                                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }}>Credit Point</th>
                                                                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }}>Overall Result</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>CCA</th>
                                                                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>CCA<br /> Max</th>
                                                                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>ESE</th>
                                                                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>ESE Max</th>
                                                                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>Theory Total</th>
                                                                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>Theory Maximum</th>
                                                                        <th style={{ textAlign: 'center', verticalAlign: "middle" }} >Theory Result</th>
                                                                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>CCA</th>
                                                                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>CCA Max</th>
                                                                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>ESE</th>
                                                                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>ESE Max</th>
                                                                        <th style={{ textAlign: 'center', verticalAlign: "middle" }} >Practical Total</th>
                                                                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>Practical Maximum</th>
                                                                        <th style={{ textAlign: 'center', textAlign: 'center', verticalAlign: "middle" }}>Practical Result</th>
                                                                    </tr>

                                                                </thead>
                                                                                                                                    <tbody>
                                                                                                                                    {tableData.map((row, index) => (
                                                                    <tr key={index}>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{row.category}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{row.coursecd} - {row.course}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{row.credits}</td>
                                                                  
                                                                    {/* Theory section */}
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.theory.cca}</td>
                                                                    <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", textAlign: "center", verticalAlign: "middle" }}>{row.theory.ccaMax}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.theory.ese}</td>
                                                                    <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", textAlign: "center", verticalAlign: "middle" }}>{row.theory.eseMax}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.theory.total}</td>
                                                                    <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", textAlign: "center", verticalAlign: "middle" }}>{row.theory.max}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.theory.theory_result}</td>
                                                                  
                                                                    {/* Practical section */}
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.practical.cca}</td>
                                                                    <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", textAlign: "center", verticalAlign: "middle" }}>{row.practical.ccaMax}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.practical.ese}</td>
                                                                    <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", textAlign: "center", verticalAlign: "middle" }}>{row.practical.eseMax}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.practical.total}</td>
                                                                    <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", textAlign: "center", verticalAlign: "middle" }}>{row.practical.max}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.practical.practical_result}</td>
                                                                  
                                                                    {/* Totals and grades */}
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.totalSecured}</td>
                                                                    <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", textAlign: "center", verticalAlign: "middle" }}>{row.maxMarks}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.grade}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.gradePoints}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.acquiredCredits}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{isMalpractice ? "-" : row.creditPoint}</td>
                                                                    <td
                                                                      style={{
                                                                        textAlign: "center",
                                                                        verticalAlign: "middle",
                                                                        color: row.overallResult === "Pass" ? "green" : "red",
                                                                        fontWeight: "bold",
                                                                      }}
                                                                    >
                                                                      {row.overallResult}
                                                                    </td>
                                                                  </tr>
                                                                    ))}



                                                                    {/* <tr>
                                                            <td colSpan={20} rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }}></td>
                                                            <td style={{ textAlign: 'center', verticalAlign: "middle" }}>Total</td>
                                                            <td style={{ textAlign: 'center', verticalAlign: "middle" }}>21</td>
                                                            <td>136</td>
                                                            <td rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }}></td>
                                                            </tr>
                                                        <tr>
                                                            <td style={{ textAlign: 'center', verticalAlign: "middle" }}>SGPA</td>
                                                            <td></td>
                                                            <td>6.48</td>
                                                            </tr> */}
                                                                </tbody>
                                                            </table>

                                                            <div className="txt-aln-jst m-10">
                                                                <p className="text-center">
                                                                    <span className="text-danger st-res-not">
                                                                        {/* <b>
                                                                    O-Outstanding, A+-Excellent, A-Very Good, B+-Good, B-Above Average, C-Average, P-Pass, F-Failure , Ab-Absent
                                                                     </b>  */}
                                                                        <b>{gradePoints}, Ab-Absent</b>
                                                                    </span>
                                                                </p>
                                                                <p >
                                                                    <span className="text-danger st-res-not">* The results presented on this webpage are provisional. If discrepancies are found during the verification of qualifying certificates provided by the student, the published results will be considered invalid.<br />
                                                                        * The results available through the web are intended only to provide immediate information to the examinees. They are not a substitute for the original mark lists/ grade sheets issued to the candidates. Mahatma Gandhi University reserves the right to update the contents of the web pages without notice.
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </>
                                                    ) : null
                                                    }
                                                </div>








                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                )}
                    </StudentTemplate>

        </>
            );
};

            export default Resultview;
